/**
 * Enum for fiscal doc types codes.
 * @readonly
 * @enum {String} FiscalDocTypeCodeEnum
 */

const FiscalDocTypeCodeEnum = {
  GREEK_SALE_INVOICE   : '1.1', // Τιμολόγιο Πώλησης
  GREEK_SERVICE_INVOICE: '2.1', // Τιμολόγιο Παροχής Υπηρεσιών

  GREEK_SERVICE_INVOICE_CREDIT: '2.11', // Πιστωτικό Τιμολόγιο Παροχής Υπηρεσιών

  GREEK_INVOICE_CREDIT_1: '5.1', // Πιστωτικό Τιμολόγιο / Συσχετιζόμενο
  GREEK_INVOICE_CREDIT_2: '5.2', // Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο

  GREEK_SALE_RECEIPT   : '11.1', // Απόδειξη Λιανικής Πώλησης
  GREEK_SERVICE_RECEIPT: '11.2', // Απόδειξη Παροχής Υπηρεσιών

  GREEK_RECEIPT_CREDIT    : '11.4', // Πιστωτικό Στοιχείο Λιανικής
  GREEK_RECEIPT_CASH_POS  : '8.4', // Απόδειξη Είσπραξης POS
  GREEK_RECEIPT_RETURN_POS: '8.5', // Απόδειξη Επιστροφής POS

  GREEK_DOCUMENT_ORDER       : '8.6', // Δελτίο Παραγγελίας Εστίασης
  GREEK_DOCUMENT_ORDER_CANCEL: '8.61', // Δελτίο Παραγγελίας Ακύρωσης - Internal use only
  GREEK_DOCUMENT_ORDER_RETURN: '8.62', // Δελτίο Παραγγελίας Επιστροφή - Internal use only

  GREEK_RECEIPT_SELF_SUPPLY       : '6.1', // Στοιχείο Αυτοπαράδοσης (αφορά πώληση ειδών)
  GREEK_RECEIPT_SELF_SUPPLY_CREDIT: '6.11', // Πιστωτικό Στοιχείο Αυτοπαράδοσης (αφορά πώληση ειδών)
  GREEK_RECEIPT_SELF_USE          : '6.2', // Στοιχείο Ιδιοχρησιμοποίησης (αφορά παροχή υπηρεσιών)
  GREEK_RECEIPT_SELF_USE_CREDIT   : '6.21' // Πιστωτικό Στοιχείο Ιδιοχρησιμοποίησης (αφορά παροχή υπηρεσιών)
}

export default FiscalDocTypeCodeEnum
